<!-- content begin -->
<div id="content" class="no-bottom no-top">
    <div id="top"></div>


    <!-- section begin -->
    <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)"
        data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
        <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>About the post</h1>
                    </div>
                </div>
            </div>

        </div>

    </section>
    <!-- section close -->



    <div class="row notifi_main ">
        <div class="col-md-12">
            <h2>
                Content Writer and Media Developer
            </h2>

            <p class="para_main_notify">
                ‘Content Writer & Media Developer’ for DGT’s newsletter ‘Skill Talks’ and to handle other media related
                work
            </p>
        </div>
    </div>


    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
                <div class="col-md-12">
                    <div class="row sequence">

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Project Background:</h3>

                                    <p> About DGT and ‘Skill Talks’ - The Directorate
                                        General of Training (DGT) under MSDE has initiated to publish a newsletter-
                                        ‘Skill Talks’, on monthly basis, with creative support and guidance from its
                                        knowledge partner, NIMI, Chennai. The objective of the ‘Skill Talks’ is to have
                                        an interactive well-informed Skill ecosystem by dissemination of information on
                                        policy decisions, various initiatives and good practices to its stakeholders.
                                    </p>

                                    <p> This monthly newsletter-cum-magazine covers
                                        ecosystem in 3 States/UTs and 3 industrial sectors of the economy so as to cover
                                        all 36 States/UTs during a year. DGT has constituted Sectoral Trade Course
                                        Committee(STCC) across 40 sectors to revamp the curriculum and content
                                        development. These STCCs are contributing to Skill Talks by providing a brief
                                        write-up on the sector. Hence, this newsletter would report about various
                                        skilling activities from the NSTIs and ITIs, the industry connects, innovations
                                        by trainees and faculty, interesting links, CSR initiatives, Flexi-MoUs, DST,
                                        etc.

                                    </p>
                                    <p> So far, three editions of the newsletter- ‘Skill
                                        Talks – June/July/August/September 2020’ have been published that covered News &
                                        Events with focus on activities and innovations taken by NSTIs and ITIs.
                                        Information about DGT and three editions of Skill Talks are available on DGT’s
                                        website www.dgt.nic.in. </p>


                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-graduation-cap"></i>
                                <div class="text para_cls">
                                    <h3>Key responsibilities: </h3>
                                    <p> <span class="step_no">1</span> To bring out newsletter ‘Skill Talks’ on monthly
                                        basis in a timely manner. </p>
                                    <p> <span class="step_no">2</span> To develop, write and disseminate media related
                                        items such as media advisories and news releases, speeches and briefing notes
                                        for senior officers and management. </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Qualification: </h3>
                                    <p> <span class="step_no">1</span> A graduation in Bachelor of Journalism & Mass
                                        Communication. </p>
                                    <p> <span class="step_no">2</span> A graduation in post-graduation in relevant field
                                        /business administration. </p>

                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->




                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-history"></i>
                                <div class="text para_cls">
                                    <h3>Experience:</h3>
                                    <p> At-least 8+ years of experience in the field of
                                        communication with Bachelor of Journalism & Mass Communication. A
                                        post-graduation in relevant field / business administration is desirable
                                        qualification. The experience of working in the field of vocational training
                                        would be preferred qualification.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-money"></i>
                                <div class="text para_cls">
                                    <h3>Remuneration:</h3>
                                    <p> Remuneration range in ₹ 70,000 - 1,00,000 depending on the experience and last pay
                                        drawn salary.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calendar"></i>
                                <div class="text para_cls">
                                    <h3>Last Date:</h3>
                                    <p style="color: red;"><b> Last date for Applying Online 1st June 2021 </b> </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-cogs"></i>
                                <div class="text para_cls">
                                    <h3>Skills and Competencies:</h3>
                                    <p><span class="step_no">1</span>The content writer should be capable to convert the
                                        material received from the stakeholders into a story line. </p>
                                    <p><span class="step_no">2</span> He/ She should have ability to summarise
                                        technically complex information into plain language communication product. </p>
                                    <p><span class="step_no">3</span> The content writer should have ability to
                                        coordinate for collection of quality content from officials of DGT and State
                                        government. </p>
                                    <p><span class="step_no">4</span> The write-up/contents will be forwarded in a
                                        printable format to NIMI Chennai for publishing.
                                    </p>
                                    <p><span class="step_no">5</span> The content writer would ensure bringing out
                                        timely quality work as published editions of ‘Skill Talks’ consistently. </p>
                                    <p><span class="step_no">6</span> He/ She would also be required to handle any
                                        social media campaign, press relations and media briefings and other related
                                        work.
                                    </p>
                                    <p><span class="step_no">7</span> Knowledge of latest technology driven tools for
                                        publishing newsletters would be a preferred attribute for this position.
                                    </p>


                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-globe"></i>
                                <div class="text para_cls">
                                    <h3>Nature of engagement:</h3>
                                    <p><span class="step_no">1</span> Initial engagement shall be for three months with
                                        further extension of contract as per project timeline.</p>


                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


                    </div>
                    <!-- content close -->




                    <style>
                        #section-intro {
                            background-image: url(assets/images/background/niminew.jpg);
                            background-size: cover;
                            background-position: 0% 0px;
                            height: 80vh !important;
                        }

                        .notifi_main {
                            text-align: center;
                            padding: 40px 0px;
                        }

                        .notifi_main h2 {
                            border-bottom: 6px solid #F56B55;
                            width: fit-content;
                            margin: 0 auto;
                            padding: 0px 30px;
                        }

                        .notifi_main .descrip_cls {
                            padding: 5px 0px;
                            font-weight: 500;
                            font-size: 21px;
                        }

                        .overlay-bg.t50 {
                            background: rgba(30, 30, 30, .1);
                        }

                        table {
                            width: 100%;
                            margin-top: 10px;
                        }

                        th,
                        td {
                            padding: 10px;
                        }

                        thead {
                            background-color: #F56B55;
                            color: #fff;
                        }

                        tr:nth-child(odd) {
                            background-color: #eee;
                        }

                        .step_no {
                            left: 80px;
                            height: 30px;
                            width: 30px;
                            background-color: #F56B55;
                            border-radius: 50%;
                            display: inline-block;
                            font-size: 18px;
                            text-align: center;
                            color: #fff;
                            margin-right: 10px;
                            position: absolute;
                        }

                        .para_cls p {
                            padding-left: 35px;
                        }

                        .num_marks {
                            text-align: center;
                        }

                        .last_tr {
                            background-color: #F56B55 !important;
                            color: #fff;
                        }

                        .notifi_main_table h2 {

                            width: fit-content;
                            margin: 0 auto;
                            padding: 50px 30px 10px;
                            font-size: 23px;

                        }

                        .para_main_notify {
                            padding: 20px 0px;
                            width: 50%;
                            margin: 0 auto;
                        }

                        #section-services {
                            padding: 0px !important;
                        }
                    </style>